import { render, staticRenderFns } from "./kefuOrderCom.vue?vue&type=template&id=24ada82b&scoped=true"
import script from "./kefuOrderCom.vue?vue&type=script&lang=js"
export * from "./kefuOrderCom.vue?vue&type=script&lang=js"
import style0 from "./kefuOrderCom.vue?vue&type=style&index=0&id=24ada82b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ada82b",
  null
  
)

export default component.exports